import React, { useState } from "react";
import { AnchorButton } from "components/Button/AnchorButton";
import { Button } from "components/Button/Button";
import { Theme as ButtonTheme } from "components/Button/styles/buttonThemes";
import { SelectTeamDialog } from "./SelectTeamDialog";

import { useActiveContext } from "shared/ContextSwitcher/store";
import { useSession } from "gui/session/session";
import { useMyTeamsIfLoggedIn } from "shared/teams/useMyTeams";

interface Plan {
  id: number;
  name: string;
}

type GetSubscribeUrl = (
  team: { handle: string },
  plan: { name: string }
) => string;

type GetNewTeamUrl = (plan: { name: string }) => string;

export function ButtonSubscribeToTeamPlanV2(props: {
  plan: Plan;
  getSubscribeUrl: GetSubscribeUrl;
  getNewTeamUrl: GetNewTeamUrl;
  theme: ButtonTheme;
  children: React.ReactNode;
}) {
  const activeContext = useActiveContext();

  if (!activeContext) {
    return null;
  }

  if (activeContext.type === "team") {
    const { plan, getSubscribeUrl, theme, children } = props;

    return (
      <AnchorButton
        theme={theme}
        size="M"
        href={getSubscribeUrl(activeContext, plan)}
      >
        {children}
      </AnchorButton>
    );
  } else {
    return <ButtonSelectTeamIfAny {...props} />;
  }
}

function ButtonSelectTeamIfAny(props: {
  plan: Plan;
  getSubscribeUrl: GetSubscribeUrl;
  getNewTeamUrl: GetNewTeamUrl;
  theme: ButtonTheme;
  children: React.ReactNode;
}) {
  const activeContext = useActiveContext();
  let teams = useMyTeamsIfLoggedIn(useSession());

  if (!activeContext || !teams) {
    return null;
  }

  const { plan, getNewTeamUrl, theme, children } = props;
  teams = teams.filter(
    (team) =>
      ["admin"].includes(team.membership.role) && team.service_tier.is_public
  );

  if (teams.length === 0) {
    return (
      <AnchorButton theme={theme} size="M" href={getNewTeamUrl(plan)}>
        {children}
      </AnchorButton>
    );
  } else {
    return <ButtonSelectTeam {...props} />;
  }
}

function ButtonSelectTeam(props: {
  plan: Plan;
  getSubscribeUrl: GetSubscribeUrl;
  getNewTeamUrl: GetNewTeamUrl;
  theme: ButtonTheme;
  children: React.ReactNode;
}) {
  const { plan, getSubscribeUrl, getNewTeamUrl, theme, children } = props;

  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);

  return (
    <>
      <Button theme={theme} size="M" onClick={() => setIsOpen((open) => !open)}>
        {children}
      </Button>

      <SelectTeamDialog
        isOpen={isOpen}
        close={close}
        plan={plan}
        getSubscribeUrl={getSubscribeUrl}
        getNewTeamUrl={getNewTeamUrl}
      />
    </>
  );
}
